import React from 'react';
import './PriceComparatorReport.css';
import {
	IconDownload,
	IconDropDownArrow,
	IconSegmentoMarketplace,
	IconSegmentoOnlineStore,
	IconSegmentoSuper,
} from '../Icons';
import { t } from 'i18next';

// Datos del producto que se está viendo
const productData = {
	product_title: 'Frutos secos con chocolate',
	chart_image_url: '/assets/images/sample-report-frutos-secos.webp',
	products: [
		{
			imagen: 'product01',
			producto_name: 'Frutos secos con chocolate',
			producto_subtitle: 'Mezcla premium de frutos secos',
			producto_description: 'Mezcla de almendras, nueces y avellanas cubiertas con chocolate negro premium',
			precio_sin_iva_gr: '0.85',
			peso_gr: '200',
			precio_sin_iva_kg: '4.25',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '1.03',
			precio_con_iva_kg: '5.15',
			brand_name: 'NaturaVita',
			brand_country: 'España',
			brand_flag: 'ES',
			country_source: 'España',
			flag_source: 'ES',
			segment: 'Marketplace',
		},
		{
			imagen: 'aceite-oliva-virgen',
			producto_name: 'Aceite de Oliva Virgen Extra',
			producto_subtitle: 'Aceite premium de primera prensada',
			producto_description: 'Aceite de oliva virgen extra de la variedad picual, primera prensada en frío',
			precio_sin_iva_gr: '0.12',
			peso_gr: '500',
			precio_sin_iva_kg: '0.24',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '0.15',
			precio_con_iva_kg: '0.29',
			brand_name: 'Oleum ',
			brand_country: 'España',
			brand_flag: 'ES',
			country_source: 'España',
			flag_source: 'ES',
			segment: 'Super',
		},
		{
			imagen: 'queso-manchego-curado',
			producto_name: 'Queso Manchego Curado',
			producto_subtitle: 'Queso de oveja curado 12 meses',
			producto_description: 'Queso manchego elaborado con leche de oveja manchega, curado durante 12 meses',
			precio_sin_iva_gr: '0.45',
			peso_gr: '250',
			precio_sin_iva_kg: '1.80',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '0.54',
			precio_con_iva_kg: '2.18',
			brand_name: 'La Mancha',
			brand_country: 'España',
			brand_flag: 'ES',
			country_source: 'España',
			flag_source: 'ES',
			segment: 'Marketplace',
		},
		{
			imagen: 'jamón-ibérico-bellota',
			producto_name: 'Jamón Ibérico de Bellota',
			producto_subtitle: 'Jamón 100% ibérico de bellota',
			producto_description: 'Jamón ibérico puro de bellota, curado durante 36 meses en bodegas naturales',
			precio_sin_iva_gr: '1.20',
			peso_gr: '100',
			precio_sin_iva_kg: '12.00',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '1.45',
			precio_con_iva_kg: '14.52',
			brand_name: 'Dehesa Real',
			brand_country: 'España',
			brand_flag: 'ES',
			country_source: 'España',
			flag_source: 'ES',
			segment: 'Online Store',
		},
		{
			imagen: 'vino-tinto-reserva',
			producto_name: 'Vino Tinto Reserva',
			producto_subtitle: 'Vino tinto reserva de la Rioja',
			producto_description: 'Vino tinto reserva elaborado con uvas tempranillo, envejecido 24 meses en barrica',
			precio_sin_iva_gr: '0.08',
			peso_gr: '750',
			precio_sin_iva_kg: '0.11',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '0.10',
			precio_con_iva_kg: '0.13',
			brand_name: 'Bodegas Rioja',
			brand_country: 'España',
			brand_flag: 'ES',
			country_source: 'España',
			flag_source: 'ES',
			segment: 'Marketplace',
		},
		{
			imagen: 'chocolate-negro-70',
			producto_name: 'Chocolate Negro 70% Cacao',
			producto_subtitle: 'Chocolate negro premium con 70% cacao',
			producto_description: 'Chocolate negro elaborado con cacao de origen único, 70% de cacao puro',
			precio_sin_iva_gr: '0.35',
			peso_gr: '100',
			precio_sin_iva_kg: '3.50',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '0.42',
			precio_con_iva_kg: '4.24',
			brand_name: 'Chocolatier',
			brand_country: 'Francia',
			brand_flag: 'FR',
			country_source: 'Francia',
			flag_source: 'FR',
			segment: 'Marketplace',
		},
		{
			imagen: 'miel-multifloral',
			producto_name: 'Miel Multifloral Natural',
			producto_subtitle: 'Miel pura de flores silvestres',
			producto_description: 'Miel natural recolectada de flores silvestres de montaña, sin procesar',
			precio_sin_iva_gr: '0.18',
			peso_gr: '500',
			precio_sin_iva_kg: '0.36',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '0.22',
			precio_con_iva_kg: '0.44',
			brand_name: 'Mieles del Valle',
			brand_country: 'España',
			brand_flag: 'ES',
			country_source: 'España',
			flag_source: 'ES',
			segment: 'Marketplace',
		},
		{
			imagen: 'café-arábica-grano',
			producto_name: 'Café Arábica en Grano',
			producto_subtitle: 'Café arábica tostado natural',
			producto_description: 'Café arábica de altura, tostado naturalmente sin aditivos artificiales',
			precio_sin_iva_gr: '0.25',
			peso_gr: '250',
			precio_sin_iva_kg: '1.00',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '0.30',
			precio_con_iva_kg: '1.21',
			brand_name: 'Café del Mundo',
			brand_country: 'Italia',
			brand_flag: 'IT',
			country_source: 'Italia',
			flag_source: 'IT',
			segment: 'Marketplace',
		},
		{
			imagen: 'té-verde-japonés',
			producto_name: 'Té Verde Japonés Sencha',
			producto_subtitle: 'Té verde premium de primera cosecha',
			producto_description: 'Té verde sencha de primera cosecha, cultivado en las montañas de Japón',
			precio_sin_iva_gr: '0.40',
			peso_gr: '100',
			precio_sin_iva_kg: '4.00',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '0.48',
			precio_con_iva_kg: '4.84',
			brand_name: 'Tea Garden',
			brand_country: 'Reino Unido',
			brand_flag: 'UK',
			country_source: 'Reino Unido',
			flag_source: 'UK',
			segment: 'Marketplace',
		},
		{
			imagen: 'sal-maldon-premium',
			producto_name: 'Sal Maldon Premium',
			producto_subtitle: 'Sal marina natural en escamas',
			producto_description: 'Sal marina natural en escamas, recolectada artesanalmente en las costas de Essex',
			precio_sin_iva_gr: '0.15',
			peso_gr: '250',
			precio_sin_iva_kg: '0.60',
			peso_kg: '1',
			moneda_simbolo: '€',
			precio_con_iva_gr: '0.18',
			precio_con_iva_kg: '0.73',
			brand_name: 'Maldon Salt',
			brand_country: 'Reino Unido',
			brand_flag: 'UK',
			country_source: 'Reino Unido',
			flag_source: 'UK',
			segment: 'Super',
		},
	],
};

export const PriceComparatorReport = ({ setCurrentStep }: { setCurrentStep: (step: string) => void }) => {
	return (
		<div className="price-report__row">
			<div className="price-report__container">
				<div className="price-report__header">
					<div className="price-report__header__left">
						<h1 className="price-report__header__title">{t('price_comparator.report.header.title')}</h1>
						<p className="price-report__header__description">{productData.product_title}</p>
					</div>
					<div className="price-report__header__actions">
						<button className="price-report__header__download">
							<IconDownload />
							{t('price_comparator.report.header.download')}
						</button>
						<button
							className="price-report__header__button"
							//onClick={() => setCurrentStep('saved')}>
							onClick={() => {
								setCurrentStep('detail');
							}}>
							{t('price_comparator.step_saved.button_compare')}
						</button>
					</div>
				</div>
				<figure className="price-report__figure">
					<img
						src={productData.chart_image_url}
						alt="Price Report"
						height={523}
						width={1216}
						className="price-report__figure__image"
					/>
				</figure>
				<div className="price-report__body">
					<div className="price-report__body__content">
						<div className="price-report__filter">
							<div className="price-report__filter__item">
								<label className="price-report__filter__label">{t('price_comparator.report.filter.segment')}</label>
								<select className="price-report__filter__select">
									<option value="">Todos</option>
									<option value="Marketplace">Marketplace</option>
									<option value="Online Store">Online Store</option>
									<option value="Super">Super</option>
								</select>
								<IconDropDownArrow className="price-report__filter__arrow" />
							</div>
							<div className="price-report__filter__item">
								<label className="price-report__filter__label">{t('price_comparator.report.filter.brand')}</label>
								<input
									type="text"
									className="price-report__filter__input"
								/>
							</div>
							<div className="price-report__filter__item">
								<label className="price-report__filter__label">{t('price_comparator.report.filter.source')}</label>
								<input
									type="text"
									className="price-report__filter__input"
								/>
							</div>
							<div className="price-report__filter__item">
								<label className="price-report__filter__label">{t('price_comparator.report.filter.country')}</label>
								<select className="price-report__filter__select">
									<option value="">Todos</option>
									<option value="España">España</option>
									<option value="Francia">Francia</option>
									<option value="Italia">Italia</option>
									<option value="Reino Unido">Reino Unido</option>
								</select>
								<IconDropDownArrow className="price-report__filter__arrow" />
							</div>
							<div className="price-report__filter__item">
								<label className="price-report__filter__label">{t('price_comparator.report.filter.product')}</label>
								<input
									type="text"
									className="price-report__filter__input"
								/>
							</div>
							<div className="price-report__filter__item">
								<label className="price-report__filter__label">{t('price_comparator.report.filter.weight')}</label>
								<input
									type="text"
									className="price-report__filter__input"
								/>
							</div>
						</div>
						<div className="price-report__top">
							<div className="price-report__top__col">10 {t('price_comparator.report.filter.products')}</div>
							<div className="price-report__top__col">
								<select className="price-report__top__select">
									<option value="DESC">{t('price_comparator.report.filter.sort_by_low')}</option>
									<option value="ASC">{t('price_comparator.report.filter.sort_by_high')}</option>
								</select>
							</div>
						</div>
						<div className="price-report__table">
							{productData.products.map((item, itemIndex) => (
								<div
									key={itemIndex}
									className="report__price__producto">
									<div className="col report__price__col_image report__price__image_container">
										<img
											src={`./assets/images/${item.imagen}.png`}
											alt={item.producto_name}
											width={37}
											height={37}
											className="report__price__producto-imagen"
										/>
									</div>
									<div className="col report__price__col_data">
										<div className="report__price__col_data_top">
											<p className="report__price__producto-name">{item.producto_name}</p>
											<p className="report__price__producto-subtitle">{item.producto_subtitle}</p>
										</div>
										<p className="report__price__producto-description">{item.producto_description}</p>
									</div>
									<div className="col report__price__col_prices report__price__col_prices_filled">
										<div className="report__price__row">
											<span className="report__price__col_prices_num report__price__col_prices-bold">
												{item.precio_sin_iva_gr} €
											</span>
											<span className="report__price__col_prices_size">{item.peso_gr}gr</span>
										</div>
										<div className="report__price__row">
											<span className="report__price__col_prices_num report__price__col_prices-bold">
												{item.precio_sin_iva_kg} €
											</span>
											<span className="report__price__col_prices_size">{item.peso_kg}kg</span>
										</div>
									</div>

									<div className="col report__price__col_prices ">
										<div className="report__price__row">
											<span className="report__price__col_prices_num ">{item.precio_con_iva_gr} €</span>
											<span className="report__price__col_prices_size">{item.peso_gr}gr</span>
										</div>
										<div className="report__price__row">
											<span className="report__price__col_prices_num ">{item.precio_con_iva_kg} €</span>
											<span className="report__price__col_prices_size">{item.peso_kg}gr</span>
										</div>
									</div>
									<div className="col report__price__col_brand">
										<span className="report__price__col_brand_title">{item.brand_country}</span>
										<img
											src={`./assets/images/${item.brand_flag}.png`}
											className="report__price__col_brand_img"
											alt={item.brand_country}
											width={36}
											height={24}
										/>
									</div>
									<div className="col report__price__col_flag">
										<span className="report__price__col_flag_title">{item.brand_name}</span>
										<img
											src={`./assets/images/${item.flag_source}.png`}
											className="report__price__col_flag_img"
											alt={item.flag_source}
											width={36}
											height={24}
										/>
									</div>
									<div className="col report__price__col_segment">
										<span className="report__price__col_segment_title">{item.segment}</span>
										{item.segment === 'Marketplace' && <IconSegmentoMarketplace />}
										{item.segment === 'Online Store' && <IconSegmentoOnlineStore />}
										{item.segment === 'Super' && <IconSegmentoSuper />}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
